// biome-ignore lint/style/useImportType: <explanation>
import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { UncontrolledTooltip } from 'reactstrap';
import { SERVICE_NAME } from '~constants/app';
import { searchInventorys, searchProducts } from '~graphql/queries';
import type {
  Product,
  SearchInventorysQuery,
  SearchInventorysQueryVariables,
  SearchProductsQuery,
  SearchProductsQueryVariables,
} from '~types/api';
import { formatCurrency } from '~utils/formatter';
import { executeQuery } from '~utils/graphql';
import { getPublicImageUrl } from '~utils/image';
import { calculatePrice } from '~utils/price';

const SaleProductAlert: React.FC<{ productId: string; className?: string }> = ({
  productId,
  className,
}) => {
  const [saleProduct, setSaleProduct] = useState<Product>();
  const [inventory, setInventory] = useState<number>();
  useEffect(() => {
    executeQuery<SearchProductsQuery, SearchProductsQueryVariables>(
      searchProducts,
      {
        filter: {
          product_brand_id: { eq: process.env.REACT_APP_HOMULA_BRAND_ID },
          copied_product_id: { eq: productId },
          product_public_status: { ne: '非公開' },
          suspended: { ne: true },
          out_of_stock: { ne: true },
        },
      }
    ).then(async (res) => {
      if (res.data?.searchProducts?.items?.length) {
        const product = res.data.searchProducts.items[0];
        const inventory = await executeQuery<
          SearchInventorysQuery,
          SearchInventorysQueryVariables
        >(searchInventorys, { filter: { product_id: { eq: product!.id } } });
        setInventory(
          inventory.data?.searchInventorys?.items?.reduce(
            (prev, item) => prev + (item?.inventory ?? 0),
            0
          )
        );
        setSaleProduct(res.data.searchProducts.items[0] as Product);
        return;
      }
      setSaleProduct(undefined);
    });
  }, [productId]);

  const handleClick = useCallback((e) => {
    e.stopPropagation();
  }, []);

  if (!saleProduct || !inventory) {
    return null;
  }

  return (
    <Link
      to={`/sale/${saleProduct.collections?.items?.[0]?.collection_id}`}
      onClick={handleClick}
    >
      <div className={className}>
        <div className="mb-2">
          <span className="font-weight-bold mr-2">
            さらにお得に注文できます
          </span>
          <Link
            to={`/sale/${saleProduct.collections?.items?.[0]?.collection_id}`}
            onClick={handleClick}
            style={{ textDecoration: 'underline' }}
          >
            詳細を見る
          </Link>
        </div>
        <div className="d-flex align-items-center mb-2">
          <div className="mr-3">
            <img
              style={{ objectFit: 'cover' }}
              src={getPublicImageUrl(
                saleProduct.imageKeys?.items?.[0]?.imageKey,
                { w: 60, h: 60 }
              )}
            />
          </div>
          <div className="d-flex flex-column h-100 justify-content-between">
            <div className="text-black-50">
              <s className="mr-2">
                {formatCurrency(
                  calculatePrice(
                    saleProduct.product_retail_price!,
                    saleProduct.product_wholesale_rate!
                  )
                )}
              </s>
              <span className="text-danger mr-2">
                {formatCurrency(
                  calculatePrice(
                    saleProduct.product_retail_price!,
                    saleProduct.product_sale_wholesale_rate!
                  )
                )}
              </span>
              <i className="text-muted">残り{inventory}点</i>
            </div>
            <div>発送元：{SERVICE_NAME}</div>
            <div className="d-flex flex-wrap">
              <div className="rounded-pill bg-gray mr-2 px-2 font-weight-bold">
                最短翌日発送
              </div>
              <div className="rounded-pill bg-gray mr-2 px-2 font-weight-bold">
                1点から注文可能
              </div>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default SaleProductAlert;
